var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPriceList)?_c('div',[_c('ul',{staticClass:"nav collage-photo-item__actions"},[_c('li',{staticClass:"nav-item"},[_c('ButtonToggleCart',{attrs:{"loading":_vm.loading,"action":_vm.actionCart},on:{"click":function($event){return _vm.toggleSelection()}}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }